export const daysBetween = (firstDate, secondDate) => {
	const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
	return Math.round(Math.abs((firstDate - secondDate) / oneDay));
};
